<template>
  <v-form
      ref="form"
      v-model="valid"
      lazy-validation
  >
    <v-container>
      <div class="mt-0 mb-5">
        <h2>{{isNew ? '庫腹占有率計算マスタ登録' : '庫腹占有率計算マスタ編集'}}</h2>
      </div>

      <v-row>
        <v-col cols="4">
          <v-select label="12都市区分"
            v-model="masterData.city_code"
            :items="city12List"
            dense
            :readonly="!isNew"
            :loading="loading"
            :disabled="loading"
            :rules="[required]"
          ></v-select>
        </v-col>
        <!-- 右：アラート（展開アニメーション付き） -->
        <v-col cols="8">
          <v-slide-x-transition mode="out-in">
            <v-alert
              v-if="showCityAlert"
              :key="alertKey"
              :type="isExists && isNew ? 'error' : 'info'"
              border="left"
              colored-border
              elevation="1"
              class="ma-0"
              dense
            >
              <div v-if="isExists && isNew">
                <span class="text-error">既にデータが存在します。別の12都市区分を選択してください。</span><br>&nbsp;
              </div>
              <div v-else-if="isZentai">
                全体の 比重/実運用時最大収容可能容積率 は <span class="text-error">必須項目</span> です。<br>&nbsp;
              </div>
              <div v-else>
                各都市の 比重 は <span class="text-info">任意項目</span> です。<br>未入力の場合 全体 の値で庫腹占有率が算出されます。
              </div>
            </v-alert>
          </v-slide-x-transition>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :hide-default-header="true"
            :hide-default-footer="true"
            dense
            class="weight-info-table table-border"
          >
            <template v-slot:body="{}">
              <thead>
                <tr>
                  <th colspan=10 class="center">比重</th>
                </tr>
                <tr>
                  <th v-for="item in masterData.value.filter(v => v.type !== 99)" :key="item.type" class="center">
                    {{ getCityDataNo9Item(item.type).text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="item in masterData.value.filter(v => v.type !== 99)" :key="item.type">
                    <NumberTextField
                      v-model.number="item.weight"
                      :readonly="isDelete || (isExists && isNew) "
                      :rules="[requiredIf(() => isZentai)]"
                    ></NumberTextField>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row v-if="isZentai">
        <v-col cols="4">
          <v-data-table
            :hide-default-header="true"
            :hide-default-footer="true"
            dense
            class="weight-info-table table-border"
          >
            <template v-slot:body="{}">
              <thead>
                <tr>
                  <th class="center">実運用時最大収容可能容積率</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <NumberTextField
                      v-model.number="masterData.value.filter(v => v.type === 99)[0].rate_stock"
                      :readonly="isDelete || (isExists && isNew)"
                      :rules="[requiredIf(() => isZentai)]"
                    ></NumberTextField>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="col-6 text-center">
          <v-btn class="btn_font primary" width="120" v-on:click="registData()" :disabled="loading || (isExists && isNew)" v-if="!isDelete">登録</v-btn>
          <v-btn class="btn_font secondary" width="120" v-on:click="deleteData()" :disabled="loading" v-else>削除</v-btn>
        </v-col>
        <v-col class="col-6 text-center">
          <v-btn class="btn_font primary" width="120" v-on:click="close()" :disabled="loading" >キャンセル</v-btn>
        </v-col>
      </v-row>

    </v-container>
  </v-form>

</template>

<script>
import NumberTextField from '../common/Number_text_field'
import MstorageOccupancyRate from '../../model/m_storage_occupancy_rate'

import M12city from "../../model/m_12_city";

import Message from '../../Lib/Message'
import Debug from '../../Lib/Debug'

import Mixin from "../../mixins/const.js";

export default {
  mixins: [Mixin],

  props: [
    'mode',
    'targetCityCode',
    'masterDataList',
  ],

  components: {
    NumberTextField,
  },

  data: () => ({
    valid : true,
    loading : false,

    // 12都市区分リスト
    city12List: [],

    masterData: {
      city_code: null,
      value: [
        {type: 1, weight: null, rate_stock: null},
        {type: 2, weight: null, rate_stock: null},
        {type: 3, weight: null, rate_stock: null},
        {type: 4, weight: null, rate_stock: null},
        {type: 5, weight: null, rate_stock: null},
        {type: 6, weight: null, rate_stock: null},
        {type: 7, weight: null, rate_stock: null},
        {type: 8, weight: null, rate_stock: null},
        {type: 9, weight: null, rate_stock: null},
        {type: 10, weight: null, rate_stock: null},
        {type: 99, weight: null, rate_stock: null},
      ],
    },

  }),

  created: function() {
  },

  mounted: async function () {
    // v-select のデータを非同期で取得
    this.loading = true;
    const promiseArray = [];
    promiseArray.push(this.getCity12List());
    Promise.all(promiseArray);

    await this.getData(this.targetCityCode);
    this.loading = false;
  },

  methods: {
    async getCity12List() {
      Debug.log("function[getCity12List]");
      // DBから12都市情報取得
      M12city.selectList()
          .then(res => {
            if (res.data) {
              this.city12List = res.data;

              // 先頭に全体を追加
              this.city12List.unshift({text: '全体', value: '000'});

              Debug.log(this.city12List);
            }
          })
          .catch (err => {
            Message.err(err, "12都市区分を取得できませんでした");
          });
    },

    // DBから 'userid' のデータを取得
    async getData(id) {
      Debug.log('function[getData]');
      Debug.log('edit targetCityCode:' + id);
      if (id == '') {
        // 新規の場合
        return;
      }

      this.loading = true;

      try {
        const res = await MstorageOccupancyRate.getData(id);
        if (res.data) {
          this.masterData = res.data;
        }

        Debug.log(this.masterData);

      } catch (error) {
        Message.err(error, '情報を取得できませんでした');
      }

      this.loading = false;
    },

    async registData() {
      Debug.log('function[registData]');

      // Vuetify Validation
      if (!this.$refs.form.validate()) {
        //Debug.log('Validation : false');
        return;
      }


      if (!confirm("更新します。よろしいですか？")) return;
      this.loading = true;
      try {
        const res = await MstorageOccupancyRate.setMstorageOccupancyRateData(this.masterData, this.mode);
        // Debug.log(res);

        // サーバーサイドのバリデーション
        const validationMsg = res.data;
        if (validationMsg) {
          let message = "";
          if (Array.isArray(validationMsg)) {
            validationMsg.forEach(m => message += m + '\n')
          } else {
            message = validationMsg;
          }
          alert(message);

          this.loading = false;
          return;
        } else {
          //
          alert("庫腹占有率計算マスタデータを更新しました");
          this.close();
        }

      } catch (error) {
        Message.err(error, "庫腹占有率計算マスタデータを更新できませんでした");
      }

      this.loading = false;
    },

    async deleteData() {
      Debug.log('function[deleteData]');

      if (!confirm("削除します。よろしいですか？")) return;
      this.loading = true;
      try {
        const res = await MstorageOccupancyRate.delMstorageOccupancyRateData(this.targetCityCode);
        Debug.log(res);

        alert("庫腹占有率計算マスタデータを削除しました");
        this.close();
      } catch (error) {
        Message.err(error, "庫腹占有率計算マスタデータを削除できませんでした");
      }

      this.loading = false;
    },

    close() {
      this.$emit("closeEvt");
    },

  },

  computed: {
    isDelete() {
      return this.mode == "delete";
    },

    isNew() {
      return this.mode == "new";
    },

    // v-select が何か選択されている時だけアラート表示
    showCityAlert() {
      return !!this.masterData.city_code;
    },

    // 全体かどうか
    isZentai() {
      return this.masterData.city_code === '000';
    },

    // トランジション用の key
    alertKey() {
      if (!this.masterData.city_code) return 'none';
      return `city-${this.masterData.city_code}`;
    },

    // 既にマスタデータが存在する12都市区分か
    isExists() {
      return this.masterDataList.some(item => item.city_code === this.masterData.city_code);
    },
  },

  watch: {
    // city_code が変わるたびに呼ばれる
    'masterData.city_code'() {
      // 初期表示時など oldVal が undefined のときはスルーしたい場合は if を付ける
      if (!this.$refs.form) return

      // city_code によって required 条件が変わるので、再度検証
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    }
  },

}

</script>


<style scoped>
.container {
  position: relative;
  width: 95%    !important;
  left: 0;
  margin: 10px;
}

.btn_font {
  color: white;
}


.v-text-field {
  padding-top: 2px;
  padding-bottom: 2px;
  margin-top: 4px;
  margin-bottom: 4px;
}

.v-input {
  padding-top: 2px;
  padding-bottom: 2px;
  margin-top: 4px;
  margin-bottom: 4px;
}

/** 比重情報 */
.weight-info-table ::v-deep .v-text-field {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.weight-info-table ::v-deep .v-text-field input {
  text-align: right;
}
.weight-info-table th {
  background-color: #EEE;
  font-size: 16px !important;
  font-weight: bold;
}

</style>
